function configurateur() {
  return {

    // ── State principal ──────────────────────────────────────
    state: {
      metal:      null,   // ex: 'OB' | 'OJ' | 'OR'
      pierres:    {       // une clé par position
        G1: null,
        G2: null,
        G3: null,
        M4: null,
        D5: null,
        D6: null,
        D7: null,
      },
      taille:     null,   // ex: 54
      prixTotal:  null,   // calculé dynamiquement
      isValid:    false,  // true quand toutes les positions sont remplies
    },

    isLoading: false,
    shareMessage: null,
    activePosition: null,

    // ── Données chargées depuis les metaobjects ──────────────
    bijou:   null,   // entrée conf_bijou
    pierres: [],     // entrées conf_pierre
    metaux:  [],     // entrées conf_metal

    // ── Tailles disponibles ──────────────────────────────────
    tailles: [48,49,50,51,52,53,54,55,56,57,58,59,60],

    // ── Init ────────────────────────────────────────────────
    async init() {
    await this.chargerMetaobjects()

    // Indicateur scroll flèche mobile
    this.$nextTick(() => {
      const slots = document.querySelector('.conf-slots')
      const wrap  = document.querySelector('.conf-slots-wrap')
      if (slots && wrap) {
        const update = () => {
          const atEnd = slots.scrollLeft + slots.clientWidth >= slots.scrollWidth - 2
          wrap.classList.toggle('is-end', atEnd)
        }
        slots.addEventListener('scroll', update, { passive: true })
        update()
        const arrow = document.querySelector('.conf-slots-arrow')
        if (arrow) {
          arrow.addEventListener('click', () => {
            slots.scrollBy({ left: 100, behavior: 'smooth' })
          })
        }
      }
    })

    // 1. Priorité à l'URL
    const params = new URLSearchParams(window.location.search)
    const configUrl = params.get('config')
    if (configUrl) {
        this.restaurerConfig(configUrl)
        return
    }

    // 1b. Params plats (depuis lien panier)
    if (params.get('metal')) {
        this.restaurerParamsFlats(params)
        return
    }

    // 2. Sinon localStorage
    const lsKey = 'bb_config_' + (this.bijou?.slug || '7pierres')
    const configLocal = localStorage.getItem(lsKey)
    if (configLocal) {
        this.restaurerConfig(configLocal)
        return
    }

    // 3. Métal par défaut défini dans le metaobject
    const metalDefaut = this.metaux.find(m => m.default === true)
    if (metalDefaut) {
        this.state.metal = metalDefaut.code
    }

    this.calculerPrix()
    },

    // ── Chargement des metaobjects via Storefront API ────────
    async chargerMetaobjects() {
      const data = window.__configurateur
      this.bijou   = data.bijou
      this.metaux  = [...data.metaux].sort((a, b) => a.order - b.order)
      this.pierres = [...data.pierres].sort((a, b) => a.order - b.order)
      this.i18n    = data.i18n || {}

      // Générer les positions dynamiquement depuis le metaobject
      const positions = this.bijou.positions.split(',')
      const pierresState = {}
      positions.forEach(pos => { pierresState[pos.trim()] = null })
      this.state.pierres = pierresState
      this.activePosition = positions[0].trim()

      console.log('Données chargées :', { bijou: this.bijou, pierres: this.pierres, metaux: this.metaux, positions })
    },

    // ── Calcul du prix ───────────────────────────────────────
    calculerPrix() {
      if (!this.bijou) return

      // 1. Prix de base avec majoration taille éventuelle (bagues uniquement)
      let base = this.bijou.prix_base_ht
      if (this.bijou.type_bijou === 'bague' && this.state.taille && this.state.taille >= this.bijou.seuil_taille) {
        base = base * (1 + this.bijou.taux_majoration)
      }

      // 2. Suppléments pierres
      let supplements = 0
      for (const pos of Object.keys(this.state.pierres)) {
        const slug = this.state.pierres[pos]
        if (!slug) continue
        const pierre = this.pierres.find(p => p.slug === slug)
        if (pierre && pierre.supplement_ht > 0) {
          supplements += pierre.supplement_ht
        }
      }

      this.state.prixTotal = base + supplements

      // 3. Validation — toutes les positions et le métal doivent être remplis, taille requise pour les bagues
      const toutesPositionsRemplies = Object.values(this.state.pierres).every(v => v !== null)
      const tailleValide = this.bijou.type_bijou !== 'bague' || this.state.taille !== null
      this.state.isValid = toutesPositionsRemplies && this.state.metal !== null && tailleValide
    },

    // ── Helpers ──────────────────────────────────────────────
    setPierre(position, slug) {
      this.state.pierres[position] = slug
      this.calculerPrix()
    },

    setMetal(code) {
      this.state.metal = code
      this.calculerPrix()
    },

    setTaille(taille) {
      this.state.taille = parseInt(taille)
      this.calculerPrix()
    },

    prixFormate() {
      if (!this.state.prixTotal) return '—'
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
      }).format(this.state.prixTotal)
    },

    supplementFormate(ht) {
      if (!ht || ht <= 0) return ''
      return '+\u202f' + new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(ht)
    },

    async ajouterAuPanier() {
        if (!this.state.isValid) return

        this.isLoading = true

        try {
            // ── Générer l'image finale ───────────────────────────
            const imageUrl = await this.genererImageFinale()

            // ── Properties ──────────────────────────────────────
            const properties = { 'Métal': this.metaux.find(m => m.code === this.state.metal)?.label }
            if (this.bijou.type_bijou === 'bague') properties['Taille'] = this.state.taille
            const configId = Date.now().toString(36) + Math.random().toString(36).slice(2)

            // Positions dynamiques
            for (const [position, slug] of Object.entries(this.state.pierres)) {
              const posNum = position.replace(/\D/g, '')
              properties[posNum] = this.pierres.find(p => p.slug === slug)?.label || slug
              properties[`_${position}`] = slug || ''
            }

            properties['_metal']     = this.state.metal
            properties['_image']     = imageUrl
            properties['_config_id'] = configId

            // ── Items ────────────────────────────────────────────
            const items = []

            items.push({
            id:         this.bijou.variantId,
            quantity:   1,
            properties: properties,
            })

            const occurrences = {}
            for (const pos of Object.keys(this.state.pierres)) {
            const slug = this.state.pierres[pos]
            if (!slug) continue
            const pierre = this.pierres.find(p => p.slug === slug)
            if (!pierre || pierre.supplement_ht === 0 || !pierre.variantId) continue
            occurrences[slug] = (occurrences[slug] || 0) + 1
            }
            for (const [slug, qty] of Object.entries(occurrences)) {
            const pierre = this.pierres.find(p => p.slug === slug)
            items.push({
                id:       pierre.variantId,
                quantity: qty,
                properties: { '_type': 'supplement-pierre', '_pierre': pierre.label, '_config_id': configId },
            })
            }

            if (this.bijou.type_bijou === 'bague' && this.state.taille >= this.bijou.seuil_taille) {
            items.push({
                id:       this.bijou.variantMajoration,
                quantity: 1,
                properties: { '_type': 'supplement-taille', '_taille': this.state.taille, '_config_id': configId },
            })
            }

            // ── Appel AJAX ───────────────────────────────────────
            const response = await fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({
                items,
                sections:     ['cart-drawer', 'cart-bubble'],
                sections_url: window.location.pathname,
            }),
            })

            if (!response.ok) {
            const err = await response.json()
            console.log('Réponse API complète :', JSON.stringify(err, null, 2))
            throw new Error(err.description || 'Erreur lors de l\'ajout au panier')
            }

            const data = await response.json()

            // ── Mettre à jour le cart drawer avec le HTML frais ──
            const cartDrawerEl = document.querySelector('cart-drawer')
            if (cartDrawerEl && data.sections) {
            const parser = new DOMParser()

            if (data.sections['cart-drawer']) {
                const doc      = parser.parseFromString(data.sections['cart-drawer'], 'text/html')
                const newInner = doc.querySelector('.cart-drawer')
                if (newInner) cartDrawerEl.innerHTML = newInner.innerHTML
            }

            const toggleEl = document.getElementById('cart-drawer-toggle')
            if (toggleEl && data.sections['cart-bubble']) {
                const doc      = parser.parseFromString(data.sections['cart-bubble'], 'text/html')
                const count    = doc.querySelector('.thb-item-count')
                const existing = toggleEl.querySelector('.thb-item-count')
                if (count && existing) existing.innerHTML = count.innerHTML
            }
            } else {
            // fallback : rafraîchissement classique
            document.dispatchEvent(new CustomEvent('cart:refresh'))
            }

            // ── Ouvrir le cart drawer ────────────────────────────
            document.body.classList.add('open-cc', 'open-cart')
            if (cartDrawerEl) {
            cartDrawerEl.classList.add('active')
            cartDrawerEl.focus()
            }

        } catch (error) {
            console.error('Erreur panier :', error)
            alert((this.i18n.error_panier || 'Une erreur est survenue : ') + error.message)
        } finally {
            this.isLoading = false
        }
    },

    // ── Prévisualisation ─────────────────────────────────────────
    srcCarcasse() {
    if (!this.state.metal) return ''
    const metal = this.metaux.find(m => m.code === this.state.metal)
    if (!metal) return ''
    return window.__assets[`carcasse-${metal.slug_fichier}`] || ''
    },

    srcPierre(position) {
    const slug = this.state.pierres[position]
    if (!slug) return ''
    return window.__assets[`${slug}-${position}`] || ''
    },

    // ── Générer image finale ─────────────────────────────────────────
    async genererImageFinale() {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        const chargerImage = (url) => new Promise((resolve, reject) => {
            const img = new Image()
            img.crossOrigin = 'anonymous'
            img.onload  = () => resolve(img)
            img.onerror = () => reject(new Error(`Impossible de charger : ${url}`))
            img.src = url
        })

        // 1. Carcasse — le canvas prend les dimensions naturelles de la carcasse
        //    (évite toute déformation si la carcasse n'est pas carrée)
        const metal = this.metaux.find(m => m.code === this.state.metal)
        const urlCarcasse = window.__assets[`carcasse-${metal.slug_fichier}`]
        const imgCarcasse = await chargerImage(urlCarcasse)
        canvas.width  = imgCarcasse.naturalWidth
        canvas.height = imgCarcasse.naturalHeight
        ctx.drawImage(imgCarcasse, 0, 0)

        // 2. Calques pierres dans l'ordre des positions du bijou courant
        //    Chaque calque est dessiné à ses dimensions naturelles sans étirement
        for (const position of Object.keys(this.state.pierres)) {
            const slug = this.state.pierres[position]
            if (!slug) continue
            const urlPierre = window.__assets[`${slug}-${position}`]
            if (!urlPierre) continue
            const imgPierre = await chargerImage(urlPierre)
            ctx.drawImage(imgPierre, 0, 0)
        }

        // 3. Upload sur Cloudinary
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'))
        const formData = new FormData()
        formData.append('file', blob, 'configuration.png')
        formData.append('upload_preset', 'bb-configurateur')
        formData.append('folder', 'bb-configurateur')

        const response = await fetch('https://api.cloudinary.com/v1_1/dkb8ggaa8/image/upload', {
            method: 'POST',
            body: formData,
        })

        if (!response.ok) {
            throw new Error('Erreur upload Cloudinary')
        }

        const data = await response.json()
        return data.secure_url  // URL publique permanente
    },

    // ── Sauvegarde & partage ─────────────────────────────────────

    sauvegarderConfig() {
    const config = {
        metal:   this.state.metal,
        pierres: this.state.pierres,
        taille:  this.state.taille,
    }
    const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(config))))
    const url = `${window.location.pathname}?config=${encoded}`

    // Sauvegarder en localStorage
    const lsKey = 'bb_config_' + (this.bijou?.slug || '7pierres')
    localStorage.setItem(lsKey, encoded)

    // Mettre à jour l'URL sans recharger la page
    window.history.replaceState({}, '', url)

    const shareUrl = window.location.href

    // Mobile : modale de partage native si disponible
    if (navigator.share) {
        navigator.share({
            title: document.title,
            text: this.i18n.share_text || 'Découvrez ma création personnalisée ✨',
            url: shareUrl,
        }).catch(() => {
            // L'utilisateur a annulé ou erreur — on ne fait rien
        })
        return
    }

    // Desktop : copier le lien dans le presse-papier
    navigator.clipboard.writeText(shareUrl).then(() => {
        this.shareMessage = this.i18n.share_message_ok || 'Lien copié dans le presse-papier ✅'
        setTimeout(() => { this.shareMessage = null }, 3000)
    }).catch(() => {
        this.shareMessage = this.i18n.share_message_url || 'Lien généré dans l\'URL ✅'
        setTimeout(() => { this.shareMessage = null }, 3000)
    })
    },

    restaurerParamsFlats(params) {
    const metal  = params.get('metal')
    const taille = parseInt(params.get('taille'))
    const positions = Object.keys(this.state.pierres)
    const pierres = {}
    positions.forEach(pos => { pierres[pos] = params.get(pos) || null })
    if (metal)        this.state.metal   = metal
    if (!isNaN(taille)) this.state.taille = taille
    this.state.pierres = pierres
    this.calculerPrix()
    const allPos = Object.keys(this.state.pierres)
    this.activePosition = allPos.find(p => !this.state.pierres[p]) || allPos[0]
    },

    restaurerConfig(encoded) {
    try {
        const config = JSON.parse(decodeURIComponent(escape(atob(encoded))))
        if (config.metal)   this.state.metal   = config.metal
        if (config.pierres) this.state.pierres = config.pierres
        if (config.taille)  this.state.taille  = config.taille
        this.calculerPrix()
        const allPos = Object.keys(this.state.pierres)
        this.activePosition = allPos.find(p => !this.state.pierres[p]) || allPos[0]
    } catch (e) {
        console.warn('Configuration invalide :', e)
    }
    },

  activerPosition(pos) {
    this.activePosition = pos
  },

  avancerPosition() {
    const positions = Object.keys(this.state.pierres)
    const currentIndex = positions.indexOf(this.activePosition)
    for (let i = 1; i <= positions.length; i++) {
      const nextIdx = (currentIndex + i) % positions.length
      const nextPos = positions[nextIdx]
      if (!this.state.pierres[nextPos]) {
        this.activePosition = nextPos
        return
      }
    }
  },

  getLayerZIndex(position) {
    const order = { G1: 4, G2: 5, G3: 6, M4: 7, D5: 6, D6: 5, D7: 4 }
    return order[position] ?? 3
  },

  getPierreImage(slug) {
    return this.pierres.find(p => p.slug === slug)?.image || ''
  },

  getStoneColor(slug) {
    const colors = {
      'rubis':             '#E5003D',
      'diamant-blanc':     '#D4D4D4',
      'diamant-noir':      '#222222',
      'saphir-rose':       '#F4A0BE',
      'saphir-orange':     '#F5882A',
      'saphir-jaune':      '#F0D060',
      'saphir-bleu-clair': '#7BADD8',
      'saphir-bleu-fonce': '#1A3A7A',
      'emeraude':          '#009A6E',
      'tsavorite-claire':  '#7DC05A',
      'tsavorite-foncee':  '#2E7A36',
      'amethyste':         '#9055A2',
    }
    return colors[slug] || '#CCCCCC'
  },

  effacerConfig() {
    const lsKey = 'bb_config_' + (this.bijou?.slug || '7pierres')
    localStorage.removeItem(lsKey)
    window.history.replaceState({}, '', window.location.pathname)
    const metalDefaut = this.metaux.find(m => m.default) || this.metaux[0]
    this.state.metal  = metalDefaut ? metalDefaut.code : null
    this.state.taille = null
    // Reset dynamique des positions
    const positions = this.bijou.positions.split(',')
    const pierresState = {}
    positions.forEach(pos => { pierresState[pos.trim()] = null })
    this.state.pierres = pierresState
    this.activePosition = positions[0].trim()
    this.calculerPrix()
  },

  }
}
